import { render, staticRenderFns } from "./FaxMessage.vue?vue&type=template&id=ebbeaa80&"
import script from "./FaxMessage.vue?vue&type=script&lang=js&"
export * from "./FaxMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports